var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('taskyType',{attrs:{"type":7}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }